export const tipoSolicitudSeguro = [{
    value: "Alta de Seguro",
    label: "Alta de Seguro"
},{
    value: "Baja de Seguro",
    label: "Baja de Seguro"
} ];